import { CONTACT_ENDPOINT } from './links.ts';

// The marketing site's only API call: submit a sales-contact lead. The API
// validates + emails sales@caratuva.com (see apps/api ContactModule).

export type ContactLead = {
  companyName: string;
  contactName: string;
  email: string;
  // `| undefined` (not just optional) so callers can pass a computed
  // `value || undefined` under exactOptionalPropertyTypes.
  phone?: string | undefined;
  message?: string | undefined;
  // Honeypot — kept empty by humans; bots that auto-fill every field trip it
  // and the server silently drops the submission.
  website?: string | undefined;
};

export async function submitContactLead(input: ContactLead, signal?: AbortSignal): Promise<void> {
  const res = await fetch(CONTACT_ENDPOINT, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(input),
    ...(signal ? { signal } : {}),
  });
  if (!res.ok) {
    let message = `Request failed (${res.status})`;
    try {
      const body = (await res.json()) as { message?: string };
      if (body && typeof body.message === 'string' && body.message.length > 0) {
        message = body.message;
      }
    } catch {
      /* non-JSON error body — keep the generic message */
    }
    throw new Error(message);
  }
}
